export const COUNTRIES = [
    {
        label: "Afghanistan",
        value: "AF",
    },
    {
        label: "Australia",
        value: "AU",
    },
    {
        label: "Austria",
        value: "AT",
    },
    {
        label: "Azerbaijan",
        value: "AZ",
    },
    {
        label: "Bahrain",
        value: "BH",
    },
    {
        label: "Bangladesh",
        value: "BD",
    },

    {
        label: "China",
        value: "CN",
    },

    {
        label: "India",
        value: "IN",
    },
    {
        label: "Indonesia",
        value: "ID",
    },
    {
        label: "Iran",
        value: "IR",
    },

    {
        label: "Malaysia",
        value: "MY",
    },

    {
        label: "Nepal",
        value: "NP",
    },

    {
        label: "Oman",
        value: "OM",
    },
    {
        label: "Pakistan",
        value: "PK",
    },
    {
        label: "Palestine",
        value: "PS",
    },

    {
        label: "Qatar",
        value: "QA",
    },

    {
        label: "Saudi Arabia",
        value: "SA",
    },
    {
        label: "South Africa",
        value: "ZA",
    },

    {
        label: "Spain",
        value: "ES",
    },
    {
        label: "Sri Lanka",
        value: "LK",
    },
    {
        label: "Swaziland",
        value: "SZ",
    },
    {
        label: "Sweden",
        value: "SE",
    },
    {
        label: "Switzerland",
        value: "CH",
    },
    {
        label: "Thailand",
        value: "TH",
    },
    {
        label: "Tunisia",
        value: "TN",
    },
    {
        label: "Turkey",
        value: "TR",
    },

    {
        label: "Ukraine",
        value: "UA",
    },
    {
        label: "United Arab Emirates",
        value: "AE",
    },
    {
        label: "United Kingdom",
        value: "GB",
    },
    {
        label: "United States",
        value: "US",
    },

    {
        label: "Vietnam",
        value: "VN",
    },

    {
        label: "Yemen",
        value: "YE",
    },

    {
        label: "Zimbabwe",
        value: "ZW",
    },
];
